export const formConfigActionTypes = {
    SetConfig: 'SetConfig',
    ClearConfig: 'ClearConfig',
};
